import { render, staticRenderFns } from "./commodity-edit-form.html?vue&type=template&id=4519fc0e&scoped=true&"
import script from "./commodity-edit-form.js?vue&type=script&lang=js&"
export * from "./commodity-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519fc0e",
  null
  
)

export default component.exports